import { render } from "./productsView.vue?vue&type=template&id=1aff74b6&scoped=true"
import script from "./productsView.vue?vue&type=script&lang=js"
export * from "./productsView.vue?vue&type=script&lang=js"

import "./productsView.vue?vue&type=style&index=0&id=1aff74b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aff74b6"]])

export default __exports__